import { useCallback, useEffect, useState } from 'react';
import { OutdoorCreativeSizeHint } from '../OutdoorCreativeSizeHint';
import { useFormikContext } from 'formik';
import { BasicOutdoorCreativeProperties } from 'core/creative/OutdoorCreative';
import { OutdoorFormModel } from '../OutdoorFormModel';
import { OutdoorType } from 'core/creative/Creative';

export const useOutdoorCreativeSizeModal = <T extends OutdoorFormModel<T>>(
  model: T,
  hintModalData: any,
  setHintModalData: (modalData: any) => void
) => {
  const [sizeInstructionModalData, setSizeInstructionModalData] =
    useState<any>(hintModalData);

  const { values } = useFormikContext<{
    typeProperties: BasicOutdoorCreativeProperties & {
      outdoorType: OutdoorType;
    };
  }>();

  const isVideo = values.typeProperties.outdoorType === OutdoorType.VIDEO;
  const creativeSize = values.typeProperties.creativeSize;
  const isInstructionModalOpen = sizeInstructionModalData !== undefined;

  const closeSizeInstruction = useCallback(() => {
    setSizeInstructionModalData(undefined);
    setHintModalData(undefined);
  }, [setHintModalData]);

  const showSizeInstruction = useCallback(() => {
    const modalData = {
      component: OutdoorCreativeSizeHint,
      props: {
        sizeBoxingMap: model.sizeBoxingMap,
        creativeSize,
        isVideo,
        closeHint: closeSizeInstruction
      }
    };
    setSizeInstructionModalData(modalData);
    setHintModalData(modalData);
  }, [model, isVideo, creativeSize, setHintModalData, closeSizeInstruction]);

  useEffect(() => {
    // Close the modal if creativeSize is cleared(when creative type is changed)
    if (!creativeSize) {
      closeSizeInstruction();
    }
    // Automatically re-show the modal if showSizeInstruction(creativeSize) is changed
    else if (isInstructionModalOpen) {
      showSizeInstruction();
    }
  }, [
    isInstructionModalOpen,
    creativeSize,
    showSizeInstruction,
    closeSizeInstruction
  ]);

  return {
    onSizeInstructionBtnClick: sizeInstructionModalData
      ? closeSizeInstruction
      : showSizeInstruction
  };
};
